import React from 'react'
import ReactWOW from 'react-wow'
import { Link } from 'gatsby'


const ReversedVerticalBanner = ({data}) => {
    return (
        <div className="main-mobile-feature">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12">
                        <ReactWOW delay='.1s' animation='fadeInUp'>
                            <div className="main-banner-image">
                                <img src={data.image} alt="banner" />
                            </div>
                        </ReactWOW>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 m-auto">
                        <div className="main-feature-content text-center">
                            <div>
                                {data.title}
                                <p>{data.subtitle}</p>
                                <div className="option-item">
                                    <Link to={data.link} className="default-btn" style={{background: "#fff", color: "#1F6BF1"}} activeClassName="active" >
                                        Learn More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>                
            </div>
        </div>
    )
}

export default ReversedVerticalBanner